import { useQuery } from "@tanstack/react-query";
import {
  DISPENSATIONS_LIST_QUERY_KEY,
  DISPENSATIONS_QUERY_KEY,
  createDispensationDetailQueryKey,
  createDispensationFileQueryKey,
  fetchDispensationById,
  fetchDispensationDocumentFile,
  fetchDispensations,
  fetchDispensationsForReporting,
} from "@/api/dispensations";
import type { PaginatedResponse } from "@/features/cle-compliance/models/courseCertificate";
import type {
  DispensationEvidenceListModel,
  DispensationEvidenceModel,
  DispensationQueryParams,
} from "@/features/cle-compliance/models/dispensation";

export {
  DISPENSATIONS_LIST_QUERY_KEY,
  DISPENSATIONS_QUERY_KEY,
  createDispensationDetailQueryKey,
  createDispensationFileQueryKey,
} from "@/api/dispensations";

export const useDispensations = (params: DispensationQueryParams = {}) =>
  useQuery<PaginatedResponse<DispensationEvidenceListModel>>({
    queryKey: [...DISPENSATIONS_LIST_QUERY_KEY, params],
    queryFn: () => fetchDispensations(params),
    staleTime: 5 * 60 * 1000,
  });

export const useDispensationsForReporting = (periodId: string) =>
  useQuery<DispensationEvidenceListModel[]>({
    queryKey: [...DISPENSATIONS_QUERY_KEY, "for-reporting", periodId],
    queryFn: () => fetchDispensationsForReporting(periodId),
    staleTime: 5 * 60 * 1000,
    enabled: periodId.length > 0,
  });

export const useDispensationDocument = (id: string) =>
  useQuery<DispensationEvidenceModel>({
    enabled: id.length > 0,
    queryKey: createDispensationDetailQueryKey(id),
    queryFn: () => fetchDispensationById(id),
    staleTime: 5 * 60 * 1000,
  });

export const useDispensationDocumentFile = (id: string) =>
  useQuery<Blob>({
    enabled: id.length > 0,
    queryKey: createDispensationFileQueryKey(id),
    queryFn: () => fetchDispensationDocumentFile(id),
    staleTime: 5 * 60 * 1000,
  });
